import './NavigationData.css';
import { useState, useEffect, ReactNode } from 'react'
import { ModemData } from '../../api/Drone';
import useDroneHubConnection from '../../hooks/DroneHubConnection';
import { HubTelemetryMessage, HubTelemetrySchema } from '../../asp/DroneHub';

export type TelemetryData = {
    imei: string;
    batteryRemaining: number;
    height: number;
    speed: number;
    sputniksCount: number;
}

interface NavigationDataProps {
    drone: ModemData;
}

function NavigationData({ drone }: NavigationDataProps): ReactNode {
    const droneHub = useDroneHubConnection();
    const [updateTelemFromHub, setUpdateTelemFromHub] = useState<HubTelemetryMessage | null>(null);
    const [telemetry, setTelemetry] = useState<HubTelemetryMessage[]>([]);

    const [currentTelemetry, setCurrentTelemetry] = useState<HubTelemetryMessage>({
        imei: "0",
        batteryRemaining: [],
        height: 0,
        speed: 0,
        sputniksCount: 0
    });

    useEffect(() => {
        droneHub.connection.on('Telemetry', (message: HubTelemetryMessage) => {
            const result = HubTelemetrySchema.safeParse(message);
            if (result.success) {
                setUpdateTelemFromHub(result.data);
            } else {
                console.error(result.error);
            }
        });
    }, []);

    useEffect(() => {
        if (updateTelemFromHub) {
            setTelem(updateTelemFromHub);
        }
    }, [updateTelemFromHub]);

    useEffect(() => {
        switchTelemetry();
    }, [drone]);

    function switchTelemetry() {
        const data = telemetry.find((item) => item.imei === drone.imei);
        if (data) {
            setCurrentTelemetry(data);
        }
        else {
            console.log("Failed to find telemetry data");
        }
    }

    function setTelem(msg: HubTelemetryMessage) {
        setTelemetry((telems) => {
            const itemExists = telems.some((item) => item.imei === msg.imei);
            if (itemExists) {
                return telems.map((t) => t.imei === msg.imei ? { ...t, ...msg } : t);
            } else {
                return [...telems, { ...msg }];
            }
        });

        if (msg.imei === drone.imei) {
            setCurrentTelemetry(msg);
        }
    }

    return (
        <>
            {drone != null &&
                <div className='navigation-data t-normal'>
                    <div className='nav-box-left'>
                        <div className='nav-box-text addition-text'>ALT:</div>
                        <div className='nav-box-value'>{currentTelemetry.height.toFixed(0)} m</div>
                    </div>
                    <div className='nav-box-right'>
                        <div className='nav-box-text addition-text'>SPD:</div>
                        <div className='nav-box-value'>{currentTelemetry.speed.toFixed(1)} m/s</div>
                    </div>
                </div>
            }
        </>
    )
}

export default NavigationData;